<template>
  <section>
    <div
      class="container"
      element-loading-background="rgba(0, 0, 0, 0.8)" 
      v-loading="loading"  element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <div>
        <HeaderDateil></HeaderDateil>
      </div>
      <div class="paperdetail">
        <div style="text-align: center; font-size: 30px; font-weight: bold;padding-top: 20px;">
          {{ ExamDetail.title }}
        </div>
        <div style="display: flex; padding-top: 20px">
          <div style="padding-left: 10%; font-size: 18px">
            <span>科目：{{ExamDetail.subjectName}}</span>
          </div>
          <div style="padding-left: 1%; font-size: 18px">
            <span>姓名：{{userName}}</span>
          </div>
          <div style="padding-left: 1%; font-size: 18px">
            <span>部门：{{ExamDetail.deptName}}</span>
          </div>
          <!-- <div style="padding-left: 26%; font-size: 15px">
            <span>总分：{{ PaperDetail.totalScore }}</span>
          </div> -->
        </div>
      </div>
      <div class="zhuti">
        <!-- 所以题目 -->
        <div class="all-questions">
          <!-- 单选题 -->
          <div
            class="dxt-questions"
            v-show="dxt != 0 && abc[QuestionIndex].type == 1"
          >
            <div class="title">
              <span style="padding-left: 30px">单选题</span>
              <span style="padding-left: 10px"
                >(共 {{ dxt }} 题，合计 {{ dxtSum.toFixed(2) }} 分)</span
              >
            </div>
            <div
              class="questions-answers-box"
              v-for="(item, index) in abc"
              :key="index"
              v-show="item.type == 1 && index == QuestionIndex"
              @click="btnindex(item, index)"
              v-clickDown
            >
              <!-- 题目和答题区域 -->
              <div class="questions-answers" v-show="index == QuestionIndex">
                <div class="questions">
                  <!-- 题目展示 -->
                  <div class="subject">
                    <span class="padding-r5"> {{ index + 1 }}. </span>
                    <span class="img-size" v-html="item.title" :id="item.id"></span>
                  </div>
                  <div class="biaoji-container">
                    <div class="biaoji">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="取消标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == true"
                          class="icon"
                          @click="biaoji(item, index)"
                        >
                          <use xlink:href="#iconbiaoji" />
                        </svg>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == false"
                          class="icon"
                          @click="biaoji(item, index)"
                        >
                          <use xlink:href="#iconmark" />
                        </svg>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <!-- 选择区域 -->
                <div class="choose">
                  <ul>
                    <li
                      v-for="(items, indexs) in item.answer"
                      :key="indexs"
                      @click="radioChange(index, indexs, item)"
                    >
                      <label :for="item.Id" class="xz-label">
                        <input
                          type="radio"
                          v-model="item.value"
                          :value="items.Id"
                          @change="radioChange(index, indexs, item)"
                          :id="item.Id"
                          style=" margin-right: 10px;"
                        />
                        <span style="text-index: -2em;padding-right: 5px;"> {{String.fromCharCode(64 + parseInt(indexs+1))}}.</span>
                        {{ items.Name }}
                      </label>
                    </li>
                  </ul>
                  <div class="answer" v-if="item.Status == true">
                    <div
                      v-for="(items, indexs) in item.answer"
                      :key="indexs"
                      :id="items.Name"
                      class="right-key"
                    >
                      <span
                        class="right-keys"
                        v-if="items.IsRight == true"
                        >正确答案：{{String.fromCharCode(64 + parseInt(indexs+1))}}</span
                      >
                      <span
                        class="select-keys"
                        v-if="items.IsCheck == true"
                        >你选择的答案：{{String.fromCharCode(64 + parseInt(indexs+1))}}</span
                      >
                    </div>
                    <div class="no-answer" v-if="item.value == ''">
                      <span>你选择的答案：未作答</span>
                    </div>
                    <div class="facility-value">
                      <span v-if="item.level == 127">难易度：易</span>
                      <span v-if="item.level == 128">难易度：较易</span>
                      <span v-if="item.level == 129">难易度：一般</span>
                      <span v-if="item.level == 130">难易度：较难</span>
                      <span v-if="item.level == 131">难易度：难</span>
                    </div>
                  </div>
                  <div class="analysis" v-if="item.Status == true">
                    <span>解析：{{ item.explain }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 多选题 -->
          <div
            class="dxt-questions"
            v-show="ddxt != 0 && abc[QuestionIndex].type == 2"
          >
            <div
              class="title"
              v-show="ddxt != 0 && abc[QuestionIndex].type == 2"
            >
              <span style="padding-left: 30px">多选题</span>
              <span style="padding-left: 10px"
                >(共 {{ ddxt }} 题，合计 {{ ddxtSum.toFixed(2) }} 分)</span
              >
            </div>
            <div
              class="questions-answers-box"
              v-for="(item, index1) in abc"
              :key="index1"
              v-show="item.type == 2 && index1 == QuestionIndex"
              @click="btnindex(item, index1)"
              v-clickDown
            >
              <div class="questions-answers" v-show="index1 == QuestionIndex">
                <div class="questions">
                  <div class="subject">
                    <span class="padding-r5"> {{ index1 + 1 }}. </span>
                    <span class="img-size" v-html="item.title" :id="item.id"></span>
                  </div>

                  <div class="biaoji-container">
                    <div class="biaoji">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="取消标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == true"
                          class="icon"
                          @click="biaoji(item, index1)"
                        >
                          <use xlink:href="#iconbiaoji" />
                        </svg>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == false"
                          class="icon"
                          @click="biaoji(item, index1)"
                        >
                          <use xlink:href="#iconmark" />
                        </svg>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="choose">
                  <ul>
                    <li
                      v-for="(items, indexs1) in item.answer"
                      :key="indexs1"
                      :id="items.Name"
                    >
                      <label :for="item.Id" class="xz-label">
                        <input
                          type="checkbox"
                          v-model="items.IsCheck"
                          :value="items.Id"
                          @change="checkboxChange(index1, indexs1, item)"
                          style="margin-right: 10px;"
                          :id="item.Id"
                        />
                        <span style="text-index: -2em;padding-right: 5px;"> {{String.fromCharCode(64 + parseInt(indexs1+1))}}.</span>
                        {{ items.Name }}
                      </label>
                    </li>
                  </ul>
                  <div class="answer" v-if="item.Status == true">
                    <div class="rightanswer">
                      <div>正确答案：</div>
                      <div
                        v-for="(items, indexs) in item.answer"
                        :key="indexs"
                        class="right-key"
                      >
                        <span v-if="items.IsRight == true">{{String.fromCharCode(64 + parseInt(indexs+1))}}</span>
                      </div>
                    </div>
                    <div class="mychange">
                      <div v-if="item.MyCate != ''">我选择的答案：</div>
                      <div v-for="(aaa, bbb) in item.CheckAnswer" :key="bbb">
                        <span>{{String.fromCharCode(64 + parseInt(aaa.Value))}}</span>
                      </div>
                    </div>
                    <div class="no-answer" v-if="item.MyCate == ''">
                      <span>我选择的答案：未作答</span>
                    </div>
                    <div class="facility-value">
                      <span v-if="item.level == 127">难易度：易</span>
                      <span v-if="item.level == 128">难易度：较易</span>
                      <span v-if="item.level == 129">难易度：一般</span>
                      <span v-if="item.level == 130">难易度：较难</span>
                      <span v-if="item.level == 131">难易度：难</span>
                    </div>
                  </div>
                  <div class="analysis" v-if="item.Status == true">
                    <span>解析：{{ item.explain }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 判断题 -->
          <div
            class="dxt-questions"
            v-show="pdt != 0 && abc[QuestionIndex].type == 3"
          >
            <div
              class="title"
              v-show="pdt != 0 && abc[QuestionIndex].type == 3"
            >
              <span style="padding-left: 30px">判断题</span>
              <span style="padding-left: 10px"
                >(共 {{ pdt }} 题，合计 {{ pdtSum.toFixed(2) }} 分)</span
              >
            </div>
            <div
              class="questions-answers-box"
              v-for="(item, index2) in abc"
              :key="index2"
              v-show="item.type == 3 && index2 == QuestionIndex"
              @click="btnindex(item, index2)"
              v-clickDown
            >
              <div
                class="questions-answers"
                v-show="showQuestion[index2] == QuestionIndex"
              >
                <div class="questions">
                  <div class="subject">
                    <span class="padding-r5"> {{ index2 + 1 }}. </span>
                    <span class="img-size" v-html="item.title" :id="item.id"></span>
                  </div>

                  <div class="biaoji-container">
                    <div class="biaoji">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="取消标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == true"
                          class="icon"
                          @click="biaoji(item, index2)"
                        >
                          <use xlink:href="#iconbiaoji" />
                        </svg>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == false"
                          class="icon"
                          @click="biaoji(item, index2)"
                        >
                          <use xlink:href="#iconmark" />
                        </svg>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div
                  class="choose"
                  style="padding-left: 35px; line-height: 50px"
                >
                  <label :for="item.Id" class="xz-label">
                    <input
                      :id="item.Id"
                      :name="item.id"
                      type="radio"
                      @change="dui(index2, item)"
                      style="margin-right: 10px"
                    />
                    正确
                  </label>

                  <label class="xz-label" :for="item.Id">
                    <input
                      :id="item.Id"
                      :name="item.id"
                      type="radio"
                      @change="cuo(index2, item)"
                      style="margin-right: 10px"
                    />
                    错误
                  </label>
                  <div class="answer" v-if="item.Status == true">
                    <div
                      class="right-key"
                      v-for="(items, indexs) in item.answer"
                      :key="indexs"
                      :id="items.Name"
                    >
                      <span v-if="items.IsRight == true">正确答案：正确</span>
                      <span v-if="items.IsRight == false">正确答案：错误</span>
                      <!-- <span v-if="items.IsCheck">你选择的答案：正确</span>
                                    <span v-else>你选择的答案：错误</span> -->
                      <span
                        v-if="
                          abc[index2].CheckAnswer &&
                            abc[index2].CheckAnswer.Value == 'true'
                        "
                        >选择的答案：正确</span
                      >
                      <span
                        v-if="
                          abc[index2].CheckAnswer &&
                            abc[index2].CheckAnswer.Value == 'false'
                        "
                        >选择的答案：错误</span
                      >
                    </div>
                    <div class="no-answer">
                      <span v-if="item.MyCate == ''">选择的答案：未作答</span>
                    </div>
                    <div class="facility-value">
                      <span v-if="item.level == 127">难易度：易</span>
                      <span v-if="item.level == 128">难易度：较易</span>
                      <span v-if="item.level == 129">难易度：一般</span>
                      <span v-if="item.level == 130">难易度：较难</span>
                      <span v-if="item.level == 131">难易度：难</span>
                    </div>
                  </div>
                  <div class="analysis" v-if="item.Status == true">
                    <span>解析：{{ item.explain }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 填空题 -->
          <div
            class="dxt-questions"
            v-show="tkt != 0 && abc[QuestionIndex].type == 4"
          >
            <div
              class="title"
              v-show="tkt != 0 && abc[QuestionIndex].type == 4"
            >
              <span style="padding-left: 30px">填空题</span>
              <span style="padding-left: 10px"
                >(共 {{ tkt }} 题，合计 {{ tktSum.toFixed(2) }} 分)</span
              >
            </div>
            <div
              class="questions-answers-box"
              v-for="(item, index4) in abc"
              :key="index4"
              v-show="item.type == 4 && index4 == QuestionIndex"
              @click="btnindex(item, index4)"
              v-clickDown
            >
              <div class="questions-answers" v-show="index4 == QuestionIndex">
                <div class="questions">
                  <div class="subject">
                    <span class="padding-r5"> {{ index4 + 1 }}. </span>
                    <span class="img-size" v-html="item.title" :id="item.id"></span>
                  </div>
                  <div class="biaoji-container">
                    <div class="biaoji">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="取消标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == true"
                          class="icon"
                          @click="biaoji(item, index4)"
                        >
                          <use xlink:href="#iconbiaoji" />
                        </svg>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == false"
                          class="icon"
                          @click="biaoji(item, index4)"
                        >
                          <use xlink:href="#iconmark" />
                        </svg>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="choose">
                  <el-input
                    v-for="(items, indexs2) in item.answer"
                    @paste.native.capture.prevent="handlePaste"
                    :key="indexs2"
                    v-model="items.letter"
                    v-on:input="inputChange(index4, indexs2, item)"
                    placeholder="请输入内容"
                    style="
                                width: 95%;
                                padding-bottom: 20px;
                                "
                  >
                    <template slot="prepend">{{ indexs2 + 1 }}</template>
                  </el-input>
                  <div class="answer" v-if="item.Status == true">
                    <div
                      v-for="(items, indexs) in item.answer"
                      :key="indexs"
                      :id="items.Name"
                      class="right-key"
                    >
                      <span class="select-keys"
                        >正确答案：{{ items.Name }}</span
                      >
                      <span class="tx-keys">
                        你填写的答案：{{
                          items.letter == "" ? "无" : items.letter
                        }}
                      </span>
                    </div>
                    <div class="facility-value">
                      <span v-if="item.level == 127">难易度：易</span>
                      <span v-if="item.level == 128">难易度：较易</span>
                      <span v-if="item.level == 129">难易度：一般</span>
                      <span v-if="item.level == 130">难易度：较难</span>
                      <span v-if="item.level == 131">难易度：难</span>
                    </div>
                  </div>
                  <div class="analysis" v-if="item.Status == true">
                    <span>解析：{{ item.explain }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 问答题 -->
          <div
            class="dxt-questions"
            v-show="wdt != 0 && abc[QuestionIndex].type == 5"
          >
            <div
              class="title"
              v-show="wdt != 0 && abc[QuestionIndex].type == 5"
            >
              <span style="padding-left: 30px">问答题</span>
              <span style="padding-left: 10px"
                >(共 {{ wdt }} 题，合计 {{ wdtSum.toFixed(2) }} 分)</span
              >
            </div>
            <div
              class="questions-answers-box"
              v-for="(item, index3) in abc"
              :key="index3"
              v-show="item.type == 5 && index3 == QuestionIndex"
              @click="btnindex(item, index3)"
              v-clickDown
            >
              <div class="questions-answers" v-show="index3 == QuestionIndex">
                <div class="questions">
                  <div class="subject">
                    <span class="padding-r5"> {{ index3 + 1 }}. </span>
                    <span class="img-size" v-html="item.title" :id="item.id"></span>
                  </div>
                  <div class="biaoji-container">
                    <div class="biaoji">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="取消标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == true"
                          class="icon"
                          @click="biaoji(item, index3)"
                        >
                          <use xlink:href="#iconbiaoji" />
                        </svg>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == false"
                          class="icon"
                          @click="biaoji(item, index3)"
                        >
                          <use xlink:href="#iconmark" />
                        </svg>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="choose">
                  <el-input
                    v-for="(items, indexs2) in item.answer"
                    @paste.native.capture.prevent="handlePaste"
                    :key="indexs2"
                    v-model="items.letter"
                    type="textarea"
                    :rows="4"
                    v-on:input="inputChange(index3, indexs2, item)"
                    placeholder="请输入内容"
                    style="
                                width: 95%;
                                padding-top: 10px;
                                padding-bottom: 20px;
                                "
                  ></el-input>
                  <div class="answer" v-if="item.Status == true">
                    <div
                      v-for="(items2, indexs) in item.answer"
                      :key="indexs"
                      class="right-key"
                    >
                      <span class="select-keys"
                        >正确答案：{{ items2.Name }}</span
                      >
                      <span class="select-keys">
                        你填写的答案：{{
                          item.letter == "" ? "无" : item.letter
                        }}
                      </span>
                    </div>
                    <div class="facility-value">
                      <span v-if="item.level == 127">难易度：易</span>
                      <span v-if="item.level == 128">难易度：较易</span>
                      <span v-if="item.level == 129">难易度：一般</span>
                      <span v-if="item.level == 130">难易度：较难</span>
                      <span v-if="item.level == 131">难易度：难</span>
                    </div>
                  </div>
                  <div class="analysis" v-if="item.Status == true">
                    <span>解析：{{ item.explain }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 实操题 -->
          <div
            class="dxt-questions"
            v-show="sct != 0 && abc[QuestionIndex].type == 6"
          >
            <div
              class="title"
              v-show="sct != 0 && abc[QuestionIndex].type == 6"
            >
              <span style="padding-left: 30px">实操题</span>
              <span style="padding-left: 10px"
                >(共 {{ sct }} 题，合计 {{ sctSum.toFixed(2) }} 分)</span
              >
            </div>
            <div
              class="questions-answers-box"
              v-for="(item, index6) in abc"
              :key="index6"
              v-show="item.type == 6 && index6 == QuestionIndex"
              @click="btnindex(item, index6)"
              v-clickDown
            >
              <div class="questions-answers" v-show="index6 == QuestionIndex">
                <div class="questions">
                  <div class="subject">
                    <span class="padding-r5"> {{ index6 + 1 }}. </span>
                    <span class="img-size" v-html="item.title" :id="item.id"></span>
                  </div>
                  <div class="biaoji-container">
                    <div class="biaoji">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="取消标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == true"
                          class="icon"
                          @click="biaoji(item, index6)"
                        >
                          <use xlink:href="#iconbiaoji" />
                        </svg>
                      </el-tooltip>
                      <el-tooltip
                        class="item"
                        effect="dark"
                        content="标记"
                        placement="top"
                      >
                        <svg
                          v-if="item.bjStatus == false"
                          class="icon"
                          @click="biaoji(item, index6)"
                        >
                          <use xlink:href="#iconmark" />
                        </svg>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="choose">
                  <div class="rules-box">
                    <el-input
                      :value="item.rules"
                      placeholder="答题要求："
                      type="textarea"
                      rows="5"
                      style="
                        width: 95%;
                        padding-left: 10px;
                        padding-bottom: 20px;
                      "
                    >
                    </el-input>
                  </div>
                  <div class="goscExam">
                      <el-button type="primary" @click="EnterPapershicao(item)" style="width: 300px;margin-bottom: 10px;">进入实操考试</el-button>
                      <span style="font-size: 14px"><span style="color:red;">注意：</span> 若无法进入实操考试，请确认是否已安装实操考试插件；安转插件请点击下方插件名称
                      </span>
                      <el-link type="primary" href="/uploadfile/xtaddin_v1.1.rar">xtaddin_v1.1.rar</el-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 答题卡 -->
      <div v-if="false">
        <left
          @btnLeft="btnLfet"
          :class="[fix == true ? 'fixed' : 'leftzj']"
          ref="left"
          :questionList="questionList" v-if="questionList"
        ></left>
      </div>
      <!-- <div class="paper-time">
        <span>剩余时间</span>
        <span class="red-color">{{ hr }}:{{ mins }}:{{ sec }}</span>
      </div> -->
      <div class="tj">
        <div class="paper-progress">
          <span>当前进度</span>
          <div class="speed-box">
            <span class="speed">{{speedNum}}</span>
            <span>/</span>
            <span class="speed">{{allSum}}</span>
          </div>
          <el-progress
            style="width: 80px;"
            :show-text="false"
            :percentage="paperPercentage"
            :color="customColor"
          ></el-progress>
        </div>
        <div class="switch-topics">
          <div class="wrong-box">
            <span class="wrong-span">剩余错题机会</span>
            <span class="wrong-span"
              >{{ wrongTopic }}<i class="iconfont icon-xinaixin-fuben-copy"></i
            ></span>
          </div>
          <el-button
            type="text"
            @click="btnNextQuestion"
            :disabled="QuestionIndex == abc.length - 1"
            v-show="errShow == false"
            >下一题</el-button
          >
          <el-button
            class="el-icon-close"
            type="text"
            v-show="errShow"
          ></el-button>
        </div>
        <el-button style="width: 120px;" type="primary" @click="btnSubmit"
          >提交试卷</el-button
        >
      </div>
    </div>
    <transition name="fade">
      <div class="progress" v-if="show">
        <div style="margin-top: 40px" v-if="wrongTopic < 0">
          闯关失败
        </div>
        <div style="margin-top: 40px" v-if="wrongTopic >= 0">
          闯关成功
        </div>
        <!-- <div style="margin-top: 40px" v-if="wrongTopic==666">
          正在提交
        </div> -->
        <div style="margin-top: 20px">
          <el-progress
            type="circle"
            :color="customColors"
            :percentage="percentage"
          ></el-progress>
        </div>
        <div>
          <span v-if="percentage <= 25" style="font-size: 10px; color: gray"
            >错题次数已用完，正在提交答案...</span
          >
          <span
            v-if="percentage < 50 && percentage > 25"
            style="font-size: 10px; color: gray"
            >正在判分中...</span
          >
          <span
            v-if="percentage > 50 && percentage < 75"
            style="font-size: 10px; color: gray"
            >正在出分中...</span
          >
          <span
            v-if="percentage > 75"
            style="padding-left: 10px; font-size: 10px; color: gray"
            >正在改卷，请稍等！</span
          >
        </div>
      </div>
    </transition>
    <el-dialog  :visible.sync="submitDialogVisible" :show-close="false" width="30%">
      <span class="title-info">{{ inforText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="submitDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="Submit">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import vHeader from "../../header/index";
import HeaderDateil from '@/components/headerDateil'
import left from "../paper/left";
import * as pmiDictionary from '@/api/pmi/dictionarys'
import * as pmiDept from '@/api/pmi/dept'
import {
  SelectPaperQuestion,
  SelectPaperDetail,
  GetDetail,
  EnterPaper,
  SelectQuestion,
} from "../../../api/exam/paper";
import * as Exam from '@/api/exam/exam'

export default {
  components: {
    vHeader,
    left,
    HeaderDateil,

  },
  data() {
    return {
      //错题的个数
      wrongTopic: 5,
      //弹框提示信息
      inforText: "",
      //提交弹框的显示和隐藏
      submitDialogVisible: false,
      jindu: "",
      zongjindu: "",
      abc: [],
      dxt: 0, //单选题
      dxtSum: 0,
      tkt: 0, //填空题
      tktSum: 0,
      tktInput: null,
      pdt: 0, //判断题
      pdtSum: 0,
      wdt: 0, //问答题
      wdtSum: 0,
      wdtInput: null,
      ddxt: 0, //多选题
      ddxtSum: 0,
      sct:0,
      sctSum:0,
      Status: false,
      paperId: localStorage.getItem("paperId"),
      Ids: localStorage.getItem("Id"),
      fix: false,
      PaperDetail: [],
      ExamDetail: [],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: true,
      date: null,
      ExamStatus: true,
      loading: true, //遮罩层
      percentage: 0, //进度条进度
      customColors: [
        //进度条颜色变化
        { color: "#f56c6c", percentage: 20 },
        { color: "#e6a23c", percentage: 40 },
        { color: "#6f7ad3", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#5cb87a", percentage: 100 },
      ],
      customColor: '#409eff',
      paperPercentage: 0,
      speedNum: 0, //进度
      allSum: 0,
      show: false, //vue动画加载
      fullscreen: false, //默认全屏状态
      frequency: 0, //计算退出考试次数
      QuestionIndex: 0, //题目序号
      showQuestion: [], //保存自执行点击事件获取的index
      itemList: [],
      time: null, //考试时间
      interval: null,
      hr: 0,
      mins: 0,
      sec: 0,
      //答错的时候显示错误
      errShow: false,
      //选择的值
      checkValue: [],
      subjectList:[],
      deptList:[],
      userName:'无',
      deptName:'无',
      urlA:'',
      questionList:null,
    };
  },
  beforeRouteLeave (to, from, next) {
    sessionStorage.removeItem("list")
     next()
  },
  methods: {
    //进入考试页面
    EnterPapershicao(item) {
      let para = {
        examId: this.Ids,
        questionId:item.id,
        userId: this.$store.state.User.ids,
      };
      Exam.getShiCaoUrlNew(para).then((res)=>{
        this.urlA=res.result
        window.location.href=this.urlA
      })
    },
    //获取所有科目
    getSubjectList() {
      let _this = this;
      let data = { NamespaceId: 6 };
      pmiDictionary.getList(data).then((res) => {
        res.data.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          _this.subjectList.push(modeInfo);
        });
      });
    },
    //获取所有部门
    getCateList() {
      let _this = this;
      let para={
        Page:1,
        Limit:100,
      }
      pmiDept.getList(para).then((res) => {
        res.data.forEach(function (item, index) {
          let modeInfo = {};
          modeInfo.value = item.id;
          modeInfo.label = item.name;
          _this.deptList.push(modeInfo);
        });
      });
    },
    //点击下一题
    btnAnalysis(index) {
      if (this.abc[index].type == 1 ) {
        for (let j = 0; j < this.abc[index].answer.length; j++) {
          if (
            this.abc[index].answer[j].IsRight == true &&
            this.abc[index].answer[j].IsCheck == false
          ) {
            this.wrongTopic = this.wrongTopic - 1;
            this.errShow = true;
            setTimeout(() => {
              this.errShow = false;
            }, 1000);
          }
        }
      } else if (this.abc[index].type == 2) {
        for (let j = 0; j < this.abc[index].answer.length; j++) {
          if (
            this.abc[index].answer[j].IsRight !==
            this.abc[index].answer[j].IsCheck
          ) {
            this.wrongTopic = this.wrongTopic - 1;
            this.errShow = true;
            setTimeout(() => {
              this.errShow = false;
            }, 1000);
            break;
          }
        }
      }else if (this.abc[index].type == 3) {
        for (let j = 0; j < this.abc[index].answer.length; j++) {
          if (
            this.abc[index].answer[j].IsRight !==
            this.abc[index].answer[j].IsCheck
          ) {
            this.wrongTopic = this.wrongTopic - 1;
            this.errShow = true;
            setTimeout(() => {
              this.errShow = false;
            }, 1000);
            break;
          }
        }
      } else {
        for (let j = 0; j < this.abc[index].answer.length; j++) {
          if (
            this.abc[index].answer[j].letter !== this.abc[index].answer[j].Name
          ) {
            this.wrongTopic = this.wrongTopic - 1;
            this.errShow = true;
            setTimeout(() => {
              this.errShow = false;
            }, 1000);
            break;
          }
        }
      }
    },
    //接收子级传过来的index
    btnLfet(index) {
      this.QuestionIndex = index;
    },
    btnindex(item, index) {
      this.showQuestion.push(index);
    },
    //点击下一题
    btnNextQuestion() {
      this.QuestionIndex += 1;
      this.btnAnalysis(this.QuestionIndex - 1);
      if (this.wrongTopic == 0) {
        // this.wrongTopic=0
        this.loadings();
      }
    },
    //点击提交按钮
    btnSubmit() {
      this.submitDialogVisible = true;
      for (let k = 0; k < this.abc.length; k++) {
        if (this.abc[k].MyCate == true) {
          this.inforText = "是否现在交卷？";
        } else if (this.abc[k].MyCate == false) {
          this.inforText = "有试题未完成，是否现在交卷？";
        }
      }
    },
    //进度条变化
    Progress() {
      let res = [];
      let res2 = [];
      res = res.concat(
        this.abc.map((c) => {
          if (c.MyCate == true) {
            res2.push(c.Status);
          }
          return c.Status;
        })
      );
      this.zongjindu = res.length;
      this.jindu = res2.length;
    },
    getList() {
      let para = {
        // pagerId: parseInt(this.paperId),
        examId:this.Ids
      };
      SelectPaperQuestion(para).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].answer = JSON.parse(res.data[i].answer);
          res.data[i].bjStatus = false;
          res.data[i].MyCate = false;
          res.data[i].value = "";
          res.data[i].CheckAnswer = [];
          if (res.data[i].type == 1) {
            this.dxt += 1;
            this.dxtSum += res.data[i].score;
          } else if (res.data[i].type == 2) {
            this.ddxt += 1;
            this.ddxtSum += res.data[i].score;
          } else if (res.data[i].type == 3) {
            this.pdt += 1;
            this.pdtSum += res.data[i].score;
          } else if (res.data[i].type == 5) {
            this.wdt += 1;
            this.wdtSum += res.data[i].score;
            for (let index = 0; index < res.data[i].answer.length; index++) {
              res.data[i].answer[index].letter = "";
            }
          } else if (res.data[i].type == 4) {
            this.tkt += 1;
            this.tktSum += res.data[i].score;
            for (let index = 0; index < res.data[i].answer.length; index++) {
              res.data[i].answer[index].letter = "";
            }
          }else if (res.data[i].type == 6) {
            this.sct += 1;
            this.sctSum += res.data[i].score;
          }
        }
        this.abc = res.data;
        this.questionList=JSON.stringify(res.data)
        this.loading=false
        this.allSum = this.abc.length;
      });
    },
    radioChange(index, indexs, item) {
      this.abc[index].answer.map((v, i) => {
        if (i == indexs) {
          v.IsCheck = true;
          this.abc[index].MyCate = true;
          // this.$refs.left.Selected(index, indexs, item);
          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        } else {
          v.IsCheck = false;
          this.abc[index].MyCate = true;
          // this.$refs.left.Selected(index, indexs, item);
          this.abc[index].CheckAnswer = {
            QuestionId: item.id,
            Value: indexs + 1,
          };
        }
      });
      // this.Progress();
    },
    checkboxChange(index, indexs, item) {
      if (this.abc[index].answer[indexs].IsCheck == true) {
        this.abc[index].MyCate = true;
        // this.$refs.left.Selected(index, indexs, item);
        this.abc[index].CheckAnswer.push({
          QuestionId: item.id,
          Value: indexs + 1,
        });
      } else if (this.abc[index].answer[indexs].IsCheck == false) {
        this.abc[index].CheckAnswer.splice(indexs, 1);
      }
      if (this.abc[index].CheckAnswer.length == 0) {
        this.abc[index].MyCate = false;
        // this.$refs.left.Selected(index, indexs, item);
      }
      // this.Progress();
    },
    dui(index, item) {
      this.abc[index].answer[0].IsCheck = true;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: "true" };
      this.abc[index].MyCate = true;
      // this.Progress();
      // this.$refs.left.Selected(index, 0, item);
    },
    cuo(index, item) {
      this.abc[index].answer[0].IsCheck = false;
      this.abc[index].CheckAnswer = { QuestionId: item.id, Value: "false" };
      this.abc[index].MyCate = true;
      // this.Progress();
      // this.$refs.left.Selected(index, 0, item);
    },
    inputChange(index, indexs, item) {
      for (let i = 0; i < this.abc[index].answer.length; i++) {
        if (this.abc[index].answer[i].Name != "") {
          this.abc[index].MyCate = true;
          // this.$refs.left.Selected(index, indexs, item);
        } 
        // else if (this.abc[index].answer[i].Name == "") {
        //   this.abc[index].MyCate = false;
        //   this.$refs.left.Selected(index, indexs, item);
        // }
      }
      // this.Progress();
    },
    biaoji(item, index) {
      if (item.bjStatus == 0) {
        item.bjStatus = true;
        this.$refs.left.bj(item, index);
        this.$message({
          type: "success",
          message: "已标记!",
        });
      } else {
        item.bjStatus = false;
        this.$refs.left.bj(item, index);
        this.$message({
          type: "success",
          message: "取消标记!",
        });
      }
    },
    //动画加载
    loadings() {
      let _this=this
      this.show = true;
      if (this.percentage != 100) {
        let s = setInterval(() => {
          this.percentage += 10;
          if (this.percentage == 100) {
            clearInterval(s);
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.show = false;
            this.percentage = 0;
            setTimeout(() => {
              let allscore = 0;
              let res = [];
              for (let i = 0; i < this.abc.length; i++) {
                if (this.abc[i].CheckAnswer.length == 0) {
                  this.abc[i].CheckAnswer = { QuestionId: 0, Value: 0 };
                }
                res.push(this.abc[i].CheckAnswer);
              }
              for (let k = 0; k < _this.abc.length; k++) {
                if (_this.abc[k].MyCate == true) {
                    if(_this.abc[k].type == 1){
                        for (let j = 0; j < _this.abc[k].answer.length; j++) {
                            if (_this.abc[k].answer[j].IsRight == true &&_this.abc[k].answer[j].IsCheck == true) {
                                _this.abc[k].IsRight=true
                                allscore += _this.abc[k].score;
                                }else{
                                _this.abc[k].IsRight=false
                            }
                        }
                    }else if (_this.abc[k].type == 2) {
                        // let count=0
                        let flag=0
                        for (let j = 0; j < _this.abc[k].answer.length; j++) {
                            if (!(_this.abc[k].answer[j].IsRight==_this.abc[k].answer[j].IsCheck)) {
                                flag++;//答错的选项个数 
                            }
                        }
                        if(flag>0){//如果错误答案数量》0,就不加分,否则加分
                            _this.abc[k].IsRight=false
                             allscore +=0
                        } else{
                            _this.abc[k].IsRight=true
                            allscore += _this.abc[k].score;
                        }
                    } 
                    else if (this.abc[k].type == 3) {
                        for (let j = 0; j < this.abc[k].answer.length; j++) {
                            if (this.abc[k].answer[j].IsRight == this.abc[k].answer[j].IsCheck) {
                                    this.abc[k].IsRight=true
                                    allscore += this.abc[k].score;
                            }else{
                                this.abc[k].IsRight=false
                            }
                        }
                    }else if (this.abc[k].type == 4) {
                        let answerLegth=this.abc[k].answer.length
                        let newAnswer
                        for (let j = 0; j < answerLegth; j++) {
                            let Ids = this.abc[k].answer.map(item => item.letter);
                            let arr = new Array();
                            this.abc[k].answer.forEach((item, index) => {
                                if (!Ids.includes(item.Name)) {
                                arr.push(item);
                                }
                            });//去掉填写正确的
                            newAnswer = arr.length;//剩下的都是填写错误的
                        }
                        if(newAnswer==answerLegth){
                                this.abc[k].IsRight=false
                                allscore +=0
                            }else if(newAnswer>0){
                                allscore += (this.abc[k].score*((answerLegth - newAnswer)/answerLegth));
                                this.abc[k].IsRight=false
                            }else if(newAnswer==0){
                                 allscore += this.abc[k].score;
                                 this.abc[k].IsRight=true
                            }
                        
                    }
                } else {
                    allscore += 0;
                }
              }
              this.submitDialogVisible = false;
              this.$router.push({
                    path:'/paperDetail',
                    query: {
                      score:allscore,
                      userName:this.user.name
                    }
                  })
                  let list = JSON.stringify(this.abc);
                  localStorage.setItem("list", list);
            }, 100);
          }
        }, 50);
      }
    },
    //主动提交
    Submit() {
      this.loadings();
      this.submitDialogVisible = false;
    },
    //查询试卷信息
    getpaper() {
      let para = {
        id: this.paperId,
      };
      SelectPaperDetail(para).then((res) => {
        this.PaperDetail = res.result;
      });
    },
    //查询考试信息
    getexam() {
      let para = {
        id: this.Ids,
      };
      GetDetail(para).then((res) => {
        this.ExamDetail = res.result;
        this.wrongTopic=this.ExamDetail.subCount
      });
    },
  },
  created() {
     if(this.$store.state.User.tokens){
    
      this.userName=JSON.parse(this.$store.state.User.infos).name
      this.deptName=JSON.parse(this.$store.state.User.infos).deptName
     this.user = this.$store.state.User.ids; //获取用户个人信息
      // this.getCateList();
    }
    //左悬浮div吸顶
    window.onscroll = () => {
      var scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      if (scrollTop >= 418) {
        this.fix = true;
      } else if (scrollTop < 418) {
        this.fix = false;
      }
    };
    this.getexam();
    this.getList();
    // this.getpaper();
    
  },
  //自执行点击事件
  directives: {
    clickDown: {
      inserted(el, binging) {
        el.click();
      },
    },
  },
  mounted() {
    let list=JSON.parse(localStorage.getItem("list"))
    if(list){
      this.abc=list
    }
    this.checkValue=JSON.parse(localStorage.getItem("checkValue"))
  },
  watch: {
    dialogVisible: {
      handler() {
        if (this.dialogVisible == false) {
          clearInterval(this.timer);
        }
      },
    },
    //监听题目改变时，将选择的答案保存服务器端上面
    QuestionIndex(newVlaue, oldVlaue) {
      if (newVlaue != oldVlaue) {
        let list = JSON.stringify(this.abc);
        localStorage.setItem("list", list);
       
        // this.abc[oldVlaue].answer.forEach(item => {
        //   this.checkValue.push({
        //     id:item.id,
        //     IsCheck:item.IsCheck
        //   })
        // });
        //  localStorage.setItem("checkValue", JSON.stringify(this.checkValue));
      }
    },
    abc: {
      // 深度监听
      handler(val, oldVal) {
        let myCateList = 0;
        this.abc.forEach((item) => {
          if (item.MyCate) {
            myCateList++;
          }
        });
        this.speedNum = myCateList;
        this.paperPercentage = parseInt(100 * (this.speedNum / this.allSum));
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.container {
  width: 100%;
}
.zhuti {
  width: 70%;
  height: 800px;
  background-color: white;
  margin-top: 20px;
  margin-left: 10%;
}
.all-questions,
.dxt-questions {
  height: 90%;
}
.title {
  width: 100%;
  height: 40px;
  padding-top: 15px;
  font-size: 18px;
  background-color: #fafafa;
  border-left: 1px dashed rgb(226, 223, 223);
  border-right: 1px dashed rgb(226, 223, 223);
  border-bottom: 1px dashed rgb(226, 223, 223);
  border-top: 1px dashed rgb(226, 223, 223);
}
li {
  list-style: none;
  font-size: 30px;
  padding: 0 10px;
  /* padding-bottom: 10px; */
}
.leftzj {
  position: absolute;
  left: 13%;
  top: 170px;
}
.tj {
  position: fixed;
  right: 200px;
  top: 173px;
}
.fixed {
  position: fixed;
  left: 13%;
  top: 10px;
}
@media (max-width: 1366px){
  .tj {
    position: fixed;
    right: 100px;
    top: 173px;
  }
}
@media (max-width: 1680px) {
  .tj {
    position: fixed;
    right: 150px;
    top: 173px;
  }
}
.icon {
  width: 1em;
  height: 1em;
  font-size: 20px;
}
.icons {
  width: 1em;
  height: 1em;
  font-size: 15px;
}
.bj {
  background-color: #1a8cfe;
}
.questions {
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100%;
  justify-content: space-between;
  align-items: baseline;
  margin-right: 20px;
  border-radius: 5px;
  border: 1px solid rgb(226, 223, 223);
  padding: 0 10px;
  padding-top: 20px;
  overflow: auto;
}
.choose {
  width: 50%;
  height: 100%;
  border-radius: 5px;
  border: 1px solid rgb(226, 223, 223);
  padding-top: 20px;
  padding-left: 10px;
}
.questions-answers {
  /* border: 1px solid rgb(226, 223, 223); */
  margin-top: 20px;
  margin-bottom: 20px;
  /* padding-top: 20px; */
  display: flex;
  height: 100%;
}
.questions-answers-box {
  height: 100%;
  padding-bottom: 50px;
}
.answer {
  display: flex;
  flex-direction: column;
  width: 92%;
  border-top: 1px dashed rgb(226, 223, 223);
}
.analysis {
  width: 92%;
  border-top: 1px dashed rgb(226, 223, 223);
  line-height: 40px;
}
.mychange {
  display: flex;
  width: 150px;
  margin-top: 10px;
}
.rightanswer {
  display: flex;
  width: 150px;
  margin-top: 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.progress {
  z-index: 2000;
  text-align: center;
  position: fixed;
  left: 39.5%;
  top: 35%;
  height: 250px;
  width: 400px;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  background-color: #fafafa;
}
.subject {
  display: flex;
  align-items: baseline;
  margin-left: 10px;
  margin-right: 10px;
}
.xz-label {
  font-size: 15px;
  display: flex;
  padding: 7px 0;
  width: 100%;
  align-items: baseline;
}
.xz-label:hover {
  background-color: whitesmoke;
}
.switch-topics {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid gainsboro;
  font-size: 14px;
  height: 110px;
  width: 120px;
  margin: 10px 0;
  padding: 10px 0;
}
/* .biaoji{
background-color: blue;
} */
.biaoji-container {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.right-key {
  display: flex;
  flex-direction: column;
}
.no-answer {
  margin-top: 10px;
}
.facility-value {
  margin-top: 10px;
  color: blue;
}
.select-keys {
  margin-top: 10px;
}
.tx-keys {
  margin-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid gainsboro;
}
.paper-time {
  position: fixed;
  right: 100px;
  bottom: 480px;
  width: 120px;
  height: 50px;
  font-size: 14px;
  line-height: 25px;
  font-weight: 400;
  border: 1px solid rgb(226, 223, 223);
  border-radius: 5px;
  text-align: center;
  padding: 10px 0;
}
.red-color {
  color: red;
  font-size: 18px;
}
.wrong-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #dedede;
  padding: 10px 0;
}
.wrong-span {
  padding-top: 10px;
}
.icon-xinaixin-fuben-copy {
  color: red;
  font-size: 24px;
  padding-left: 10px;
}
.el-icon-close {
  font-size: 24px;
  color: red;
  font-weight: 800;
  background-color: rgba(255, 0, 0, 0.021);
  width: 40px;
  height: 40px;
}
img{
  max-width:98%;
  max-height:98%;
}
.img-size{
   max-width:95%;
  /* width: 280px; */
}
.img-size>p>img{
  max-width:95%;
}
.title-info{
  display: flex;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
}

.goscExam{
  margin:10px 20px;
  display: flex;
  flex-direction: column;
  line-height: 40px;
  align-items: center;
}
.rules-box{
  display: flex;
  margin-top: 10px;
}
.rules-text{
  white-space: nowrap;
}
.padding-r5{
  padding-right: 5px;
  font-size: 16px;
}
.paper-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 30px;
  height: 80px;
  border-bottom: 1px solid rgb(226, 223, 223);
  padding: 10px 0;
}
.speed {
  padding: 0 5px;
}
</style>

<style >
.subject img{
  max-width:100% !important;
}
</style>
